(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var isPreview = location.protocol === 'file:' || document.documentElement.hasAttribute('data-preview');

  /* Nav hairline on scroll */
  var nav = document.querySelector('.nav');
  function onScrollNav() { if (nav) nav.classList.toggle('is-scrolled', window.scrollY > 8); }

  /* Scroll reveal */
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
    });
  }, { rootMargin: '0px 0px -10% 0px', threshold: 0.12 }) : null;
  document.querySelectorAll('.reveal').forEach(function (el) {
    if (io && !reduced) io.observe(el); else el.classList.add('is-in');
  });

  /* Statement: words light up as you scroll through */
  var statement = document.querySelector('[data-words]');
  var words = [];
  if (statement) {
    var text = statement.textContent.trim().split(/\s+/);
    statement.innerHTML = text.map(function (w) { return '<span class="dim">' + w + '</span>'; }).join(' ');
    words = statement.querySelectorAll('span');
  }
  function onScrollWords() {
    if (!words.length) return;
    var r = statement.getBoundingClientRect();
    var vh = window.innerHeight;
    var p = (vh * 0.85 - r.top) / (r.height + vh * 0.35);
    p = Math.max(0, Math.min(1, p));
    var lit = Math.round(p * words.length);
    for (var i = 0; i < words.length; i++) words[i].classList.toggle('dim', i >= lit);
  }

  /* Gentle parallax / scale */
  var heroImg = document.querySelector('.hero__img');
  var kneadImg = document.querySelector('.knead__stage img');
  // The built-in photo needs a deeper zoom to crop out its inset circles; uploaded photos only get a gentle one.
  var kneadBase = kneadImg && /jh-glow/.test(kneadImg.getAttribute('src')) ? 1.5 : 1.12;
  function onScrollMotion() {
    if (reduced) return;
    var y = window.scrollY;
    if (heroImg && y < window.innerHeight * 1.2) {
      heroImg.style.transform = 'translateY(' + (y * 0.08) + 'px) scale(' + (1 - Math.min(y, 600) / 6000) + ')';
    }
    if (kneadImg) {
      var r = kneadImg.parentNode.getBoundingClientRect();
      var p = 1 - Math.max(0, Math.min(1, (r.top + r.height) / (window.innerHeight + r.height)));
      kneadImg.style.transform = 'scale(' + (kneadBase - p * 0.1) + ')';
    }
  }

  /* Sticky buy bar: shows once the hero buy button is out of view, hides at the final CTA */
  var buybar = document.querySelector('.buybar');
  var heroBuy = document.querySelector('.hero__buy');
  var finalBuy = document.querySelector('.final .hero__buy');
  function onScrollBar() {
    if (!buybar || !heroBuy) return;
    var past = heroBuy.getBoundingClientRect().bottom < 0;
    var atEnd = finalBuy && finalBuy.getBoundingClientRect().top < window.innerHeight;
    buybar.classList.toggle('is-visible', past && !atEnd);
  }

  var ticking = false;
  window.addEventListener('scroll', function () {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      onScrollNav(); onScrollWords(); onScrollMotion(); onScrollBar();
      ticking = false;
    });
  }, { passive: true });
  onScrollNav(); onScrollWords(); onScrollBar();

  /* Heat switch */
  var heat = document.querySelector('.heat');
  if (heat) {
    var temp = heat.querySelector('[data-temp-out]');
    var label = heat.querySelector('[data-temp-label]');
    heat.querySelectorAll('.switch button').forEach(function (b) {
      b.addEventListener('click', function () {
        heat.querySelectorAll('.switch button').forEach(function (x) { x.setAttribute('aria-pressed', x === b); });
        heat.setAttribute('data-level', b.dataset.level);
        countTo(temp, parseInt(b.dataset.temp, 10));
        label.textContent = b.dataset.label;
      });
    });
  }
  function countTo(el, to) {
    var from = parseInt(el.textContent, 10) || to;
    if (reduced || from === to) { el.textContent = to; return; }
    var start = null;
    function step(t) {
      if (!start) start = t;
      var p = Math.min(1, (t - start) / 500);
      el.textContent = Math.round(from + (to - from) * (1 - Math.pow(1 - p, 3)));
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
    setTimeout(function () { el.textContent = to; }, 650);
  }

  /* Intensity levels */
  document.querySelectorAll('.levels').forEach(function (group) {
    var btns = group.querySelectorAll('.level');
    btns.forEach(function (b) {
      b.addEventListener('click', function () {
        btns.forEach(function (x) { x.setAttribute('aria-pressed', x === b); });
        // On phones the levels are a swipe rail: bring a partly hidden card fully into view
        if (group.scrollWidth > group.clientWidth + 1) {
          group.scrollTo({ left: b.offsetLeft - 16, behavior: reduced ? 'auto' : 'smooth' });
        }
      });
    });
  });

  /* Swipe rails: page dots under each card row (dots are hidden by CSS on wider screens) */
  document.querySelectorAll('[data-rail]').forEach(function (rail) {
    var items = rail.children;
    if (items.length < 2) return;
    var dots = document.createElement('div');
    dots.className = 'rail-dots';
    dots.setAttribute('aria-hidden', 'true');
    for (var i = 0; i < items.length; i++) dots.appendChild(document.createElement('i'));
    rail.parentNode.insertBefore(dots, rail.nextSibling);
    var marks = dots.children;
    function update() {
      var max = rail.scrollWidth - rail.clientWidth;
      var idx = max > 0 && rail.scrollLeft >= max - 4 ? items.length - 1 : 0;
      if (idx === 0) {
        var left = rail.getBoundingClientRect().left;
        var best = Infinity;
        for (var j = 0; j < items.length; j++) {
          var d = Math.abs(items[j].getBoundingClientRect().left - left - 16);
          if (d < best) { best = d; idx = j; }
        }
      }
      for (var k = 0; k < marks.length; k++) marks[k].classList.toggle('is-on', k === idx);
      // Intensity levels: while swiping, the card in view becomes the active level
      if (isLevels && max > 1) {
        for (var n = 0; n < items.length; n++) items[n].setAttribute('aria-pressed', n === idx);
      }
    }
    var isLevels = rail.classList.contains('levels');
    rail.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  });

  /* Product photo sliders */
  document.querySelectorAll('[data-gallery]').forEach(function (g) {
    var track = g.querySelector('.gallery__track');
    var slides = track.children;
    var prev = g.querySelector('.gallery__nav--prev');
    var next = g.querySelector('.gallery__nav--next');
    var dotsWrap = g.querySelector('.gallery__dots');
    if (slides.length < 2) return;
    var dots = [];
    if (dotsWrap) {
      for (var i = 0; i < slides.length; i++) {
        var d = document.createElement('button');
        d.type = 'button';
        d.setAttribute('aria-label', 'Show photo ' + (i + 1));
        d.addEventListener('click', (function (n) { return function () { go(n); }; })(i));
        dotsWrap.appendChild(d);
        dots.push(d);
      }
    }
    function current() { return Math.round(track.scrollLeft / Math.max(1, track.clientWidth)); }
    function go(n) {
      n = Math.max(0, Math.min(slides.length - 1, n));
      track.scrollTo({ left: n * track.clientWidth, behavior: reduced ? 'auto' : 'smooth' });
    }
    function update() {
      var idx = current();
      dots.forEach(function (d, k) { d.setAttribute('aria-current', k === idx ? 'true' : 'false'); });
      if (prev) prev.disabled = idx <= 0;
      if (next) next.disabled = idx >= slides.length - 1;
    }
    if (prev) prev.addEventListener('click', function () { go(current() - 1); });
    if (next) next.addEventListener('click', function () { go(current() + 1); });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(current() + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(current() - 1); }
    });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  });

  /* Toast */
  var toast = document.querySelector('.toast');
  var toastTimer;
  function showToast(msg) {
    if (!toast) return;
    toast.textContent = msg;
    toast.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.classList.remove('is-visible'); }, 2600);
  }

  /* Add to bag via Shopify AJAX cart; falls back to a normal form post */
  var counts = document.querySelectorAll('.nav__count');
  function setCount(n) { counts.forEach(function (c) { c.textContent = n; c.setAttribute('data-count', n); }); }

  document.querySelectorAll('form[data-add-to-cart]').forEach(function (form) {
    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      if (isPreview) {
        var n = (parseInt(counts[0] && counts[0].textContent, 10) || 0) + 1;
        setCount(n);
        showToast('Added to your bag');
        return;
      }
      var btn = form.querySelector('[type="submit"]');
      if (btn) btn.disabled = true;
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: new FormData(form)
      }).then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return fetch(root + 'cart.js').then(function (c) { return c.json(); });
      }).then(function (cart) {
        setCount(cart.item_count);
        showToast('Added to your bag');
      }).catch(function () {
        form.submit();
      }).then(function () {
        if (btn) btn.disabled = false;
      });
    });
  });
})();
